import React, { useState, useEffect } from 'react';
import translate from '../locales/locales';
import Img from '../components/image';
import desktopVideo from '../assets/videos/desktop.mp4';
import mobileImage from '../assets/images/edi-header-mobile.jpg';
import gem from '../assets/images/icons/gem-rose.png'



function Header() {

    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });

    const [vidSource, setVidSource] = useState('');
    const [controls, setControls] = useState(translate.pause)


    function playPause() {
        var vid = document.getElementById('video');
        if (vid.paused) {
            document.getElementsByClassName('btn-pause')[0].classList.remove("play");
            vid.play();
            setControls(translate.pause);
        }

        else {
            document.getElementsByClassName('btn-pause')[0].classList.add("play");
            vid.pause();
            setControls(translate.play);

        }
    }

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });

            if (windowSize.width >= 900) {
                setVidSource(desktopVideo);
            }
            else if (windowSize.width <= 900) {
                setVidSource(mobileImage);
            }

        }
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, [windowSize.width, vidSource]);


    return (

        <div className="header angle">
            
            {windowSize.width > 600 ?
            <><button aria-label={controls} className="btn-pause" onClick={playPause}></button><video id="video" title="header" autoPlay={true} muted loop controls>
                    <source src={desktopVideo} type="video/mp4" />
                </video></> :
                <div className="mobile-img"><Img lazySrc="https://site-cbc.radio-canada.ca/site/edi/gem-load-grise.gif" src={mobileImage} alt="" /></div>}


            <div className="title">
                <Img lazySrc="https://site-cbc.radio-canada.ca/site/edi/gem-load-grise.gif" src={gem} alt="" />
                <h1 className="white">{translate.seo.title}</h1>
                <hr className="thick pink" />
                <h2 className="text-center white">{translate.seo.definition}</h2>

            </div>

        </div>
    )
}

export default Header;